import ElementStyledText from './ElementStyledText.vue';

export { ElementStyledText };
